/**
 * Simple Audio Analysis Prompt for Find Audio Context
 * Minimal prompt relying on fine-tuned model's training
 */

export const createFindAudioAnalysisPromptSimple = (): string => {
  return `FIRST: Check track duration and use correct terminology:
- Under 7 seconds: Use "mnemonic" instead of "track"
- 7 to 15 seconds: MUST use "sting" instead of "track"
- Over 15 seconds: Use "track"

Analyze this audio and provide a description following this pattern:
"[mood] [time period] [genre] [mnemonic/sting/track] with [hero instruments], [additional characteristics] atmosphere"

CRITICAL EXCLUSION RULES:
- Only mention hero instruments (main/prominent instruments, not background elements)
- DO NOT mention vocals, singing, or any vocal-related terms (male vocals, female vocals, choir, etc.)
- Only use "synth" if the track is explicitly electronic genre
- Focus on the most prominent 1-2 instruments that define the track

Focus on:
- One primary genre
- PRIORITIZE mood and characteristic tags
- Multiple mood descriptors (emotional, energetic, dark, uplifting, playful, quirky, etc.)
- Production style instead of specific instruments
- Rich atmospheric and mood descriptions

Provide a concise, natural description suitable for music library search.`;
};